// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_01da928d","outerContainer":"_18e2f993","secondaryToolbar":"_2fbe8de6","doorHangerRight":"_0fe662d2","toolbarContainer":"_232cf6e4","toolbarViewerMiddle":"_1a9ce496","progressBar":"_7966c6ab","back-to-application":"ce80cb3d","root":"_24fbe635","image":"_6296cded","image--bordered":"_371c7d1e","image--not-transparent":"_879499af","edit-button":"_2b86b8d7","actions":"d09110f3","action":"a2cf2639","avatar-input-label":"d040c08e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/index.styl
// module id = 4921
// module chunks = 39